import Big from 'big.js';

export type BigNumberInput = string | number | null | undefined;

export function toBig(value: BigNumberInput): Big {
  if (value == null || value === '') {
    return new Big(0);
  }

  try {
    return new Big(String(value));
  } catch {
    return new Big(0);
  }
}

export function toDecimalString(value: BigNumberInput): string {
  return toBig(value).toString();
}

export function isGreaterThanZero(value: BigNumberInput): boolean {
  return toBig(value).gt(0);
}

export function normalizeToPrecision(
  value: BigNumberInput,
  precision = 8,
): string {
  const normalized = toBig(value).toFixed(precision);

  if (!normalized.includes('.')) {
    return normalized;
  }

  return normalized.replace(/\.0+$|(?<=\.[0-9]*[1-9])0+$/u, '');
}
export function isGreaterThan(
  value: BigNumberInput,
  compareTo: BigNumberInput,
): boolean {
  return toBig(value).gt(toBig(compareTo));
}
